import { ExclamationTriangleIcon } from "@heroicons/react/24/outline";
import React from "react";

interface NewChatModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

export const NewChatModal: React.FC<NewChatModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
}) => {
  if (!isOpen) return null;

  return (
    <div
      data-testid="reboot-live-new-chat-modal"
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/50"
    >
      <div className="bg-[#1d1d1f] relative rounded-lg shadow-[0px_20px_25px_-5px_rgba(0,0,0,0.1),0px_10px_10px_-5px_rgba(0,0,0,0.04)] w-[512px]">
        <div className="size-full">
          <div className="box-border content-stretch flex gap-4 items-start overflow-clip p-6 relative size-full">
            {/* Warning Icon */}
            <div className="bg-red-100 relative rounded-full shrink-0 size-10 flex items-center justify-center">
              <ExclamationTriangleIcon className="w-6 h-6 text-red-600" />
            </div>

            <div className="basis-0 content-stretch flex flex-col gap-4 grow items-start min-h-px min-w-px relative shrink-0">
              {/* Text Content */}
              <div className="content-stretch flex flex-col gap-2 items-start not-italic relative shrink-0 text-white w-full">
                <h2
                  data-testid="reboot-live-new-chat-modal-title"
                  className="font-['Bebas_Neue'] font-bold leading-6 relative shrink-0 text-lg w-full"
                >
                  New Chat
                </h2>
                <p
                  data-testid="reboot-live-new-chat-modal-message"
                  className="font-normal leading-5 relative shrink-0 text-sm w-full"
                >
                  Starting a new chat will delete your current chat and report.
                  <br />
                  To keep your work, download the report before continuing.
                </p>
              </div>

              {/* Action Buttons */}
              <div className="content-stretch flex gap-3 items-center justify-end relative shrink-0 w-full">
                <button
                  data-testid="reboot-live-new-chat-modal-cancel-button"
                  onClick={onClose}
                  className="cursor-pointer relative rounded-md shrink-0 hover:opacity-80 transition-opacity"
                >
                  <div className="box-border content-stretch flex items-center justify-center overflow-clip px-4 py-2 relative rounded-[inherit]">
                    <p className="font-medium leading-5 not-italic relative shrink-0 text-sm text-nowrap text-white whitespace-pre">
                      Cancel
                    </p>
                  </div>
                  <div
                    aria-hidden="true"
                    className="absolute border border-solid border-white inset-0 pointer-events-none rounded-md shadow-[0px_1px_2px_0px_rgba(0,0,0,0.05)]"
                  />
                </button>
                <button
                  data-testid="reboot-live-new-chat-modal-confirm-button"
                  onClick={onConfirm}
                  className="bg-red-600 box-border content-stretch flex items-center justify-center overflow-clip px-4 py-2 relative rounded-md shadow-[0px_1px_2px_0px_rgba(0,0,0,0.05)] shrink-0 hover:opacity-90 transition-opacity cursor-pointer"
                >
                  <p className="font-medium leading-5 not-italic relative shrink-0 text-sm text-nowrap text-white whitespace-pre">
                    New Chat
                  </p>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
